module.exports = __webpack_public_path__ + "static/media/new_logo@3x.40ce3c89.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/new_logo@3x.png
// module id = 213
// module chunks = 1